import {createConfirmation} from 'react-confirm';
import Prompt from './Prompt';

export default (confirmation, options = {}) => createConfirmation(Prompt)({confirmation, options});
